<template>
  <div class="app-container">
    <div class="screen">
      <el-form
        label-width="200px"
        :inline="true"
        :model="screen"
        class="form-inline"
        label-position="left"
      >
        <el-form-item label="选择园区">
          <el-select
            filterable
            v-model="screen.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
            @change="ChangePark"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择设施">
          <el-cascader
            placeholder="请选择设施"
            :options="options"
            :props="{
              checkStrictly: true,
              label: 'name',
              value: 'id',
              children: 'nodes',
            }"
            v-model="screen.facility_id"
            :show-all-levels="false"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="启用日期">
          <el-date-picker
            v-model="screen.install_time"
            type="date"
            placeholder="设备启用日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同质保到期日">
          <el-date-picker
            v-model="screen.quality_guarantee_time"
            type="date"
            placeholder="合同质保到期日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="名称/编号">
          <el-input
            v-model="screen.key_words"
            placeholder="设备名称/设备编号/设备编码/规格型号"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            filterable
            v-model="screen.status"
            placeholder="请选择状态"
          >
            <el-option label="请选择" value="0"></el-option>
            <el-option label="停用" value="2"></el-option>
            <el-option label="启用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索" class="searchs">
          <el-button
            size="medium"
            type="primary"
            @click="(page = 1), fetchData()"
            >查询</el-button
          >
          <el-button size="medium" type="primary" plain @click="chongZhi()"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/equipment/add')"
        >添加</el-button
      >
      <el-button
        size="medium"
        type="info"
        @click="downloadFile()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/equipment/template')"
        >下载模板</el-button
      >
      <el-button
        size="medium"
        type="success"
        @click="leadIn()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/equipment/import')"
        >导入</el-button
      >
      <el-button
        size="medium"
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/equipment/export')"
        >导出</el-button
      >
    </div>

    <el-table
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      max-height="700"  v-loading="listLoading" 
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (page - 1) * page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.park ? scope.row.park.name : "" }}
        </template>
      </el-table-column>
      <el-table-column label="所属设施" align="center" min-width="180">
        <template slot-scope="scope">
          <span>
            {{ scope.row.facility ? scope.row.facility.code : "" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="设备名称" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="设施编码" align="center" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.code }}
        </template>
      </el-table-column>
      <el-table-column label="规格型号" align="center" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.specification }}
        </template>
      </el-table-column>
      <el-table-column label="设备编号" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.self_code }}</span>
        </template>
      </el-table-column>
      <el-table-column label="安装日期" align="center" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.install_time }}
        </template>
      </el-table-column>
      <el-table-column label="合同质保到期日" align="center" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.quality_guarantee_time }}
        </template>
      </el-table-column>
      <el-table-column label="当前状态" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.status == 1">待分配</span>
          <span v-if="scope.row.status == 2">已接单</span>
          <span v-if="scope.row.status == 3">处理中</span>
          <span v-if="scope.row.status == 4">已完成</span>
          <span v-if="scope.row.status == 5">已评价</span> -->
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="设备描述" align="center">
        <template slot-scope="scope">
          {{ scope.row.description }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="220"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="edit(scope.row)"
            v-if="roles.includes('/equipment/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="see(scope.row)"
            v-if="roles.includes('/equipment/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row)"
            v-if="roles.includes('/equipment/del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[15, 30, 50]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="700px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      @opened="openDrawer"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            :disabled="cztype != 'add'"
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            @change="formPark"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属设施" prop="facility_ids">
          <el-cascader
            placeholder="请选择设施"
            :options="FToptions"
            :disabled="cztype == 'see'"
            :props="{
              checkStrictly: true,
              label: 'name',
              value: 'id',
              children: 'nodes',
            }"
            v-model="ruleForm.facility_ids"
            :show-all-levels="false"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="设备类型" prop="facility_equipment_type_ids">
          <el-cascader
            placeholder="请选择设备类型"
            :options="EToptions"
            :disabled="cztype == 'see'"
            :props="{
              checkStrictly: true,
              label: 'name',
              value: 'id',
              children: 'nodes',
            }"
            v-model="ruleForm.facility_equipment_type_ids"
            separator="-"
            clearable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="设备名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            :disabled="cztype == 'see'"
            placeholder="请输入设备名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备规格型号" prop="specification">
          <el-input
            v-model="ruleForm.specification"
            :disabled="cztype == 'see'"
            placeholder="请输入设备规格型号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备本身的编号" prop="self_code">
          <el-input
            :disabled="cztype == 'see'"
            v-model="ruleForm.self_code"
            placeholder="请输入设备本身的编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="安装时间">
          <el-date-picker
            v-model="ruleForm.install_times"
            type="date"
            placeholder="设备安装时间"
            value-format="timestamp"
            :disabled="cztype == 'see'"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同质保到期日">
          <el-date-picker
            v-model="ruleForm.quality_guarantee_times"
            type="date"
            placeholder="合同质保到期日"
            value-format="timestamp"
            :disabled="cztype == 'see'"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="设备描述" prop="position">
          <el-input
            type="textarea"
            v-model="ruleForm.description"
            :disabled="cztype == 'see'"
            placeholder="请输入设备描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            保存
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/equipment/import'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="handleAvatarSuccess"
        :on-progress="beforeAvatarUpload"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pinyin } from "pinyin-pro";
import { infoAgo, openPark, transfer } from "@/api/index";
import {
  equipmentLists,
  getFacilityTypeList,
  getEquipmentTypeList,
  addEquipment,
  seeEquipment,
  editEquipment,
  delEquipment,
  templatetEquipment,
  exportEquipment,
} from "@/api/facility";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  data() {
    return {
      options: [],
      cztype: "",
      drawerTitle: "",
      statusList: [
        {
          name: "请选择",
          value: "0",
        },
        {
          name: "天",
          value: "1",
        },
        {
          name: "周",
          value: "2",
        },
        {
          name: "月",
          value: "3",
        },
        {
          name: "季",
          value: "4",
        },
        {
          name: "年",
          value: "5",
        },
      ],
      logDrawer: false,
      logList: [],
      token: getToken(),
      list: [],
      total: 0,
      page: 1,
      page_size: 15,
      screen: {
        park_id: "",
        status: "",
        name: "",
        key_words: "",
        install_time: "",
        quality_guarantee_time: "",
        facility_id: "",
      },

      parkList: [],
      drawer: false,
      ruleForm: {
        maintenance_transfer_reason_id: "",
        to_maintenance_type_id: "",
        source: 2,
        des: "",
        to_user_id: "",
        image: [],
        to_maintenance_type_son_id: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "blur",
          },
        ],
        park_id: [
          {
            required: true,
            message: "请选择所属园区",
          },
        ],
        facility_ids: [
          {
            required: true,
            message: "请选择所属设施",
          },
        ],
        facility_equipment_type_ids: [
          {
            required: true,
            message: "请选择设备类型",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择设备状态",
          },
        ],
      },
      pdForm: {
        id: "",
        to_user_id: "",
        maintenance_type_son_id: "",
        source: 2,
        maintenance_type: "",
        park_id: "",
      },
      fileList: [],
      file: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      uploadDisabled: false,
      maintenanceList: [],
      // 转单和派单大类
      maintenanceLists1: [],
      maintenanceTwoList: [],
      pdDrawer: false,
      ByUserList: [],
      parkId: "",
      reasonList: [],
      status: 0,
      EToptions: [],
      FToptions: [],
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      fileList: [],
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.screen.type = this.userInfo.type;
      // this.getMaintenanceList(this.userInfo.park_id);
    } else {
      this.screen.park_id = "";
    }
    if (this.userInfo.company_id !== 0) {
      this.screen.company_id = this.userInfo.company_id;
    } else {
      this.screen.company_id = "";
    }
    this.getPark();
    this.fetchData();
    this.getFTList(0);
  },
  methods: {
    openDrawer() {
      this.$refs.ruleForm.clearValidate();
    },
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });
        this.$refs.upload.clearFiles();
        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUpload(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导出
    derive() {
      let data = {
        park_id: this.screen.park_id,
        status: this.screen.status,
        key_words: this.screen.key_words,
        install_time: this.screen.install_time,
        quality_guarantee_time: this.screen.quality_guarantee_time,
        facility_id: this.screen.facility_id,
      };
      const loading = this.$loading({
          lock: true,
          text: '数据量过大，正在导出中...',
          spinner: 'el-icon-loading'
        });
      exportEquipment(data).then((res) => {
        loading.close();
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = res.name;
        // downloadElement.target="_blank"
        downloadElement.setAttribute("target", "_blank");
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(error =>{
        loading.close();
      });
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      templatetEquipment().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    // 删除
    del(val) {
      var that = this;
      const data = {
        id: val.id,
      };
      this.$confirm("确认删除？")
        .then((_) => {
          delEquipment(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 编辑
    edit(val) {
      this.cztype = "edit";
      this.ruleForm.park_id = val.park_id;
      this.drawerTitle = "编辑";
      this.getFormFTList();
      this.getETList();
      setTimeout(() => {
        this.getInfo(val.id);
      }, 500);
      // this.drawer = true;
    },
    // 查看
    see(val) {
      this.cztype = "see";
      this.ruleForm.park_id = val.park_id;
      this.drawerTitle = "查看";
      this.getFormFTList();
      this.getETList();
      setTimeout(() => {
        this.getInfo(val.id);
      }, 500);
      // this.ruleForm = val
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      seeEquipment({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        this.ruleForm = {
          id: res.data.info.id,
          name: res.data.info.name,
          park_id: res.data.info.park_id,
          status: res.data.info.status,
          specification: res.data.info.specification,
          self_code: res.data.info.self_code,
          install_times: res.data.info.install_time * 1000,
          quality_guarantee_times: res.data.info.quality_guarantee_time * 1000,
          description: res.data.info.description,
        };
        that.ruleForm.facility_ids = that.globalfunc.getParentsById(
          this.FToptions,
          res.data.info.facility_id
        );
        that.ruleForm.facility_equipment_type_ids =
          that.globalfunc.getParentsById(
            this.EToptions,
            res.data.info.facility_equipment_type_id
          );
      });
      this.drawer = true;
    },
    ChangePark() {
      this.getFTList(0);
    },
    changeName(e) {
      var that = this;
      const nameList = pinyin(this.ruleForm.name, {
        pattern: "first",
        toneType: "none",
        type: "array",
      })
        .join("")
        .toUpperCase();
      that.ruleForm.name_acronyms = nameList;
      if (that.ruleForm.pid == 0) {
        // var parkName = ''
        // this.treeData[0].children.forEach((item,index)=>{
        //   if(that.treeId == item.id){
        //     return parkName = item.name
        //   }
        // })
        // const park = pinyin(parkName,{ pattern: 'first', toneType: 'none', type: 'array' }).join('').toUpperCase()
        that.ruleForm.code = nameList;
      } else {
        that.ruleForm.code = that.oldCode + "-" + nameList;
      }
    },

    formPark(e) {
      this.getFormFTList();
    },
    addMenu() {
      this.drawerTitle = "添加设备";
      this.cztype = "add";
      this.ruleForm = {
        name: "",
        park_id: "",
        facility_ids: "",
        facility_equipment_type_ids: "",
        status: 1,
        specification: "",
        self_code: "",
        install_times: "",
        quality_guarantee_times: "",
        description: "",
      };
      this.getETList();
      this.drawer = true;
    },
    getFormFTList() {
      let data = {
        is_page: 2,
        is_tree: 2,
        park_id: this.ruleForm.park_id,
      };
      getFacilityTypeList(data).then((res) => {
        this.FToptions = this.globalfunc.getTreeData(res.data.lists);
      });
    },
    getETList() {
      let data = { is_page: 2, is_tree: 2 };
      getEquipmentTypeList(data).then((res) => {
        this.EToptions = this.globalfunc.getTreeData(res.data.lists);
      });
    },
    getFTList() {
      let data = { is_page: 2, is_tree: 2, park_id: this.screen.park_id };
      getFacilityTypeList(data).then((res) => {
        this.options = this.globalfunc.getTreeData(res.data.lists);
        this.options.unshift({ name: "全部", id: "" });
      });
    },
    chongZhi() {
      this.screen = {
        park_id: "",
        status: "",
        name: "",
        key_words: "",
        install_time: "",
        quality_guarantee_time: "",
        facility_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },

    handleSizeChange(val) {
      this.page_size = val;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 编辑
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.facility_id =
            this.ruleForm.facility_ids[this.ruleForm.facility_ids.length - 1];
          this.ruleForm.facility_equipment_type_id =
            this.ruleForm.facility_equipment_type_ids[
              this.ruleForm.facility_equipment_type_ids.length - 1
            ];
          this.ruleForm.install_time = this.ruleForm.install_times / 1000;
          this.ruleForm.quality_guarantee_time =
            this.ruleForm.quality_guarantee_times / 1000;
          editEquipment(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.drawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 添加
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.facility_id = this.ruleForm.facility_ids.join();
          this.ruleForm.facility_equipment_type_id =
            this.ruleForm.facility_equipment_type_ids.join();
          this.ruleForm.install_time = this.ruleForm.install_times / 1000;
          this.ruleForm.quality_guarantee_time =
            this.ruleForm.quality_guarantee_times / 1000;
          addEquipment(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.drawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      if (this.screen.facility_id) {
        this.screen.facility_id = this.screen.facility_id.join();
      }
      this.listLoading = true;
      this.screen.page = this.page;
      this.screen.page_size = this.page_size;
      equipmentLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.searchs {
  ::v-deep .el-form-item__label {
    opacity: 0 !important;
    display: block;
  }
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
::v-deep .screen {
  padding: 0 50px;
  border-bottom: 1px solid #e4e7ed;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 23%;
  }
}
.card {
  .des-box {
    p {
      padding: 0 10px;
      &.reason {
        color: #ff3300;
      }
    }
  }
}
::v-deep .el-message {
  width: 100px !important;
  height: 10px;
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
</style>
